module.exports = __webpack_public_path__ + "ed93c3a34bdb1cf949032a963e2d02f6.jpg";